var isImageDark = function (_a) {
    var img = _a.img, _b = _a.threshold, threshold = _b === void 0 ? 128 : _b, offset = _a.bottomOffset;
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var width = img.naturalWidth || img.width;
    var height = img.naturalHeight || img.height;
    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(img, 0, 0);
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var pixels = imageData.data;
    var totalBrightness = 0;
    var pixelCount = 0;
    var startRow = 0;
    if (offset) {
        startRow = Math.max(0, canvas.height - offset);
    }
    for (var y = startRow; y < canvas.height; y++) {
        for (var x = 0; x < canvas.width; x++) {
            var idx = (y * canvas.width + x) * 4;
            var r = pixels[idx];
            var g = pixels[idx + 1];
            var b = pixels[idx + 2];
            var alpha = pixels[idx + 3] / 255;
            // Смешиваем с белым фоном, если пиксель прозрачный
            var rWithAlpha = r * alpha + 255 * (1 - alpha);
            var gWithAlpha = g * alpha + 255 * (1 - alpha);
            var bWithAlpha = b * alpha + 255 * (1 - alpha);
            var luminance = 0.299 * rWithAlpha + 0.587 * gWithAlpha + 0.114 * bWithAlpha;
            totalBrightness += luminance;
            pixelCount++;
        }
    }
    var averageBrightness = pixelCount > 0 ? totalBrightness / pixelCount : 0;
    return averageBrightness < threshold;
};
export default isImageDark;
//# sourceMappingURL=isImageDark.js.mapvar isImageDark = function (_a) {
    var img = _a.img, _b = _a.threshold, threshold = _b === void 0 ? 128 : _b, offset = _a.bottomOffset;
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var width = img.naturalWidth || img.width;
    var height = img.naturalHeight || img.height;
    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(img, 0, 0);
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var pixels = imageData.data;
    var totalBrightness = 0;
    var pixelCount = 0;
    var startRow = 0;
    if (offset) {
        startRow = Math.max(0, canvas.height - offset);
    }
    for (var y = startRow; y < canvas.height; y++) {
        for (var x = 0; x < canvas.width; x++) {
            var idx = (y * canvas.width + x) * 4;
            var r = pixels[idx];
            var g = pixels[idx + 1];
            var b = pixels[idx + 2];
            var alpha = pixels[idx + 3] / 255;
            // Смешиваем с белым фоном, если пиксель прозрачный
            var rWithAlpha = r * alpha + 255 * (1 - alpha);
            var gWithAlpha = g * alpha + 255 * (1 - alpha);
            var bWithAlpha = b * alpha + 255 * (1 - alpha);
            var luminance = 0.299 * rWithAlpha + 0.587 * gWithAlpha + 0.114 * bWithAlpha;
            totalBrightness += luminance;
            pixelCount++;
        }
    }
    var averageBrightness = pixelCount > 0 ? totalBrightness / pixelCount : 0;
    return averageBrightness < threshold;
};
export default isImageDark;
//# sourceMappingURL=isImageDark.js.map